(function ($) {
  'use strict';

  //get url via Form data attr
  var searchUrlData = $('.search-filter__form').data('fb-url');

  //Global Funnelback search URL
  var searchURL = searchUrlData + '?';

  //if dev
  if (window.location.href.indexOf('localhost') > -1) {
    searchURL = '?';
  }

  var searchParamsStatic = 'collection=une~sp-news&form=json_landing&sort=date'; //add &clive=une-<collection> for collection specific results
  var loadMoreParams = 'collection=une~sp-news&form=json_landing&sort=date'; //add &clive=une-<collection> for collection specific results

  //Global media paths Global vars
  var featuredNewsHTML = '';
  var newsHTML = '';
  var maxwordsTitle = 15;
  var maxwordsSummary = 15;
  var $grid;
  var filterDateRange = [];
  var filterCategory;
  var filterKeywords;
  var resultSummary;

  var resultItemTemplates = {
    partialBgImage: '<div class="content-grid__image" style="background-image: url({backgroundImageUR' +
        'L});"></div>',
    featured: `<div class="content-grid__column content-grid__column--featured-in-search">
                    <a href="{url}" class="content-grid__item content-grid__item--tall {hasImageClass}">
                        {backgroundImage}
                        <div class="content-grid__date">{date}</div>
                        <div class="content-grid__featured-tag">FEATURED</div>
                        <div class="content-grid__content">
                            <h2 class="content-grid__title">{title}</h2>
                            <p class="content-grid__description">{description}</p>
                        </div>
                    </a>
                </div>`,
    newsTall: `<div class="content-grid__item-container">
                    <a href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--tall {hasImageClass}">
                        {backgroundImage}
                        <div class="content-grid__date">{date}</div>
                        <div class="content-grid__content">

                            <h2 class="content-grid__title">{title}</h2>
                            <p class="content-grid__description">{description}</p>
                        </div>
                    </a>
                </div>`,
    newsTaller: `<div class="content-grid__item-container">
                    <a href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--taller {hasImageClass}">
                        {backgroundImage}
                        <div class="content-grid__date">{date}</div>
                        <div class="content-grid__content">
                            <div class="content-grid__tag content-grid__tag--purple {tagClassDarker}">
                                <span>{category}</span>
                            </div>
                            <h2 class="content-grid__title">{title}</h2>
                            <p class="content-grid__description">{description}</p>
                        </div>
                    </a>
                </div>`,
    socialFacebook: `<div class="content-grid__item-container">
                        <a target="_blank" href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--social">
                            <div class="content-grid__date">{date}</div>
                            <div class="content-grid__content">
                                <p class="content-grid__description">{description}</p>
                                <div class="content-grid__social-info">
                                    <div class="content-grid__social-info-username">
                                        {username}
                                    </div>
                                    <div class="content-grid__social-info-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17"><path fill="#FFF" fill-rule="evenodd" d="M8.661.003L6.502 0C4.077 0 2.51 1.608 2.51 4.097v1.889H.34a.34.34 0 0 0-.34.34v2.736c0 .188.152.34.34.34h2.17v6.905c0 .188.152.34.34.34h2.83a.34.34 0 0 0 .34-.34V9.401h2.537a.34.34 0 0 0 .34-.34V6.326a.34.34 0 0 0-.339-.34H6.021v-1.6c0-.77.183-1.161 1.186-1.161H8.66A.34.34 0 0 0 9 2.884V.343a.34.34 0 0 0-.339-.34z"/></svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>`,
    socialTwitter: `<div class="content-grid__item-container">
                        <a target="_blank" href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--purple content-grid__item--social">
                            <div class="content-grid__date">{date}</div>
                            <div class="content-grid__content">
                                <p class="content-grid__description">{description}</p>
                                <div class="content-grid__social-info">
                                    <div class="content-grid__social-info-username">
                                        @{username}
                                    </div>
                                    <div class="content-grid__social-info-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14"><path fill="#FFF" fill-rule="evenodd" d="M17 1.635a6.974 6.974 0 0 1-2.003.55A3.499 3.499 0 0 0 16.53.255c-.674.4-1.42.69-2.214.846a3.488 3.488 0 0 0-5.943 3.181A9.902 9.902 0 0 1 1.182.639a3.486 3.486 0 0 0 1.08 4.657 3.475 3.475 0 0 1-1.58-.436v.043a3.49 3.49 0 0 0 2.798 3.42 3.497 3.497 0 0 1-1.576.06 3.492 3.492 0 0 0 3.259 2.422A6.998 6.998 0 0 1 0 12.248a9.872 9.872 0 0 0 5.346 1.568c6.416 0 9.924-5.315 9.924-9.924 0-.151-.004-.302-.01-.451A7.086 7.086 0 0 0 17 1.635z"/></svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>`,
    socialInstagram: `<div class="content-grid__item-container">
                        <a target="_blank" href="{url}" class="content-grid__item content-grid__item--has-image">
                            {backgroundImage}
                            <div class="content-grid__date">{date}</div>
                            <div class="content-grid__content">
                                <div class="content-grid__social-info">
                                    <div class="content-grid__social-info-username">
                                        {username}
                                    </div>
                                    <div class="content-grid__social-info-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill="#FFF" fill-rule="evenodd" d="M1.99 0h11.52c1.095 0 1.99.81 1.99 1.99v11.52c0 1.18-.895 1.99-1.99 1.99H1.99C.895 15.5 0 14.69 0 13.51V1.99C0 .81.895 0 1.99 0zm9.301 1.722a.7.7 0 0 0-.697.698v1.67a.7.7 0 0 0 .697.698h1.752a.7.7 0 0 0 .698-.698V2.42a.7.7 0 0 0-.698-.698h-1.752zm2.457 4.833h-1.364c.129.421.199.868.199 1.33 0 2.578-2.158 4.668-4.818 4.668-2.66 0-4.818-2.09-4.818-4.668 0-.462.07-.909.2-1.33H1.721v6.547c0 .34.278.617.617.617h10.793a.618.618 0 0 0 .616-.617V6.555zM7.765 4.7c-1.72 0-3.113 1.35-3.113 3.016s1.394 3.017 3.113 3.017 3.113-1.35 3.113-3.017c0-1.666-1.394-3.016-3.113-3.016z"/></svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>`,
    socialYoutube: `<div class="content-grid__item-container">
                        <a href="{url}?rel=0" data-featherlight="iframe" class="content-grid__item  content-grid__item--youtube content-grid__item--modal content-grid__item--has-image">
                            {backgroundImage}
                            <div class="content-grid__date">{date}</div>
                            <div class="content-grid__content">
                                <div class="content-grid__social-info">
                                    <div class="content-grid__social-info-username">
                                        {username}
                                    </div>
                                    <div class="content-grid__social-info-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16"><path d="M22.5 2.5c-.3-1-1-1.7-2-2-1.8-.5-8.9-.5-8.9-.5s-7 0-8.8.5c-1 .3-1.7 1-2 2C.3 4.2.3 7.9.3 7.9s0 3.7.5 5.4c.3 1 1 1.7 2 2 1.8.5 8.8.5 8.8.5s7.1 0 8.8-.5c1-.3 1.7-1 2-2 .5-1.8.5-5.4.5-5.4s0-3.7-.4-5.4zM9.4 11.3V4.5l5.9 3.4-5.9 3.4z" fill="#fff"/></svg>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>`,
    socialLinkedin: `<div class="content-grid__item-container">
                            <a href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--light content-grid__item--social">
                                <div class="content-grid__date">{date}</div>
                                <div class="content-grid__content">
                                    <div class="content-grid__title">{title}</div>
                                    <div class="content-grid__social-info">
                                        <div class="content-grid__social-info-username">
                                            {username}
                                        </div>
                                        <div class="content-grid__social-info-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M14.7 0H1.2C.5 0 0 .5 0 1.1v13.6c0 .6.5 1.1 1.2 1.1h13.5c.7 0 1.2-.5 1.2-1.1V1.1c0-.6-.6-1.1-1.2-1.1zm-10 13.5H2.3V6h2.3l.1 7.5zM3.5 4.9c-.7 0-1.4-.6-1.4-1.4s.6-1.3 1.4-1.3 1.4.6 1.4 1.4-.6 1.3-1.4 1.3zm10 8.6h-2.3V9.8c0-.9 0-2-1.2-2s-1.4 1-1.4 1.9v3.7H6.2V6h2.2v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.1z" fill="#239ba4"/></svg>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>`,
    socialSoundcloud: `<div class="content-grid__item-container">
                            <a href="{url}" class="content-grid__item content-grid__item--adaptive-height content-grid__item--light content-grid__item--social">
                                <div class="content-grid__date">{date}</div>
                                <div class="content-grid__content">
                                    <div class="content-grid__title">{title}</div>
                                    <div class="content-grid__social-info">
                                        <div class="content-grid__social-info-username">
                                            {username}
                                        </div>
                                        <div class="content-grid__social-info-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M14.7 0H1.2C.5 0 0 .5 0 1.1v13.6c0 .6.5 1.1 1.2 1.1h13.5c.7 0 1.2-.5 1.2-1.1V1.1c0-.6-.6-1.1-1.2-1.1zm-10 13.5H2.3V6h2.3l.1 7.5zM3.5 4.9c-.7 0-1.4-.6-1.4-1.4s.6-1.3 1.4-1.3 1.4.6 1.4 1.4-.6 1.3-1.4 1.3zm10 8.6h-2.3V9.8c0-.9 0-2-1.2-2s-1.4 1-1.4 1.9v3.7H6.2V6h2.2v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.1z" fill="#239ba4"/></svg>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>`,
    newsCct: `<div class="content-grid__column">
                <a href="{url}" class="content-grid__item content-grid__item--tall {hasImageClass}">
                  {backgroundImage}                  
                  <div class="content-grid__date">{date}</div>
                  <div class="content-grid__content">
                      <h2 class="content-grid__title">{title}</h2>
                      <p class="content-grid__description">{description}</p>
                  </div>
                </a>
            </div>`,
    newsListingCCT: `<div class="news-listing__item">
                      <a href="{url}">
                        <div class="news-listing__date">{date}</div>
                        <div class="news-listing__title">{title}</div>
                        <div class="news-listing__text">
                          <p>{description}</p>
                        </div>
                      </a>
                    </div>`
  };

  function getAJAXNews(searchURL, autoscroll) {
    $('.btn--search-loadmore, .spinner--search-loadmore').addClass('search-ajax-loading');
    var noDataMsg = document.querySelector('.no-data-msg');

    var jqxhr = $.getJSON(searchURL, function () {}).done(function (data) {
        //console.log(data); Was this a load more request?
        if (!data.fullResults) {
          loadMoreParams = data.loadMore;
          resultSummary = data.resultsSummary;
          var results = data.results;
        } else {
          //at page load
          loadMoreParams = data.fullResults.loadMore;
          var results = data.fullResults.results;
          resultSummary = data.fullResults.resultsSummary;
          if(noDataMsg) {
            noDataMsg.style.display = 'none';
          }

          //populate category dropdown on first run
          /*
          if ($('.search-filter__category').data('populated') !== true) {
            var categories = data.Categories;
            $.each(categories, function(index, category) {
              $('.search-filter__category').append(
                $('<option>', {
                  value: category.queryStringParam,
                  text:  category.label
                })
              );
            });
            $('.search-filter__category').data('populated', true);
          }

          //on category dropdown change
          $('.search-filter__category').change(function() {
            filterCategory = $(this).val();
            showHideClearFiltersBtn();
          });
          */
        }

        /**
         * Featured News
         */

        var featuredResults = data.featured;
        // if there are featured news and they are not already appended (subsequent
        // calls upon Load More)
        if (featuredResults && !featuredNewsHTML) {
          //iterate featured results
          featuredResults
            .forEach(function (result) {
              var nmItem = resultItemTemplates.featured;
              nmItem = nmItem
                .replace(/{url}/g, result.url)
                .replace(/{date}/g, formatDate(result.date))
                .replace(/{title}/g, trunc(result.title, maxwordsTitle))
                .replace(/{description}/g, trunc(stripHtml(result.summary), maxwordsSummary));

              //if there is a background image
              if (result.image) {
                nmItem = nmItem
                  .replace(/{backgroundImage}/g, resultItemTemplates.partialBgImage.replace(/{backgroundImageURL}/g, encodeURI(result.image)))
                  .replace(/{hasImageClass}/g, 'content-grid__item--has-image');
              } else {
                nmItem = nmItem
                  .replace(/{backgroundImage}/g, '')
                  .replace(/{hasImageClass}/g, '')
                  .replace(/{tagClassDarker}/g, 'content-grid__tag--purple-darker');
              }

              featuredNewsHTML += nmItem;
            });

          //append to Featured section
          $('.content-grid__container--search-featured .content-grid__columns').append(featuredNewsHTML);
        }

        /**
         * Regular News
         */

        newsHTML = '';

        updatePaginationInfo();

        //iterate over search results
        results.forEach(function (result) {
          //if item is standard news
          if (result.source == 'news') {
            var nmItem = resultItemTemplates.newsTall;

            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{title}/g, trunc(result.title, maxwordsTitle))
              .replace(/{description}/g, trunc(stripHtml(result.summary), maxwordsSummary));

            //if there is a background image
            if (result.image) {
              nmItem = nmItem
                .replace(/{backgroundImage}/g, resultItemTemplates.partialBgImage.replace(/{backgroundImageURL}/g, encodeURI(result.image)))
                .replace(/{hasImageClass}/g, 'content-grid__item--has-image')
                .replace(/{backgroundImage}/g, '')
                .replace(/{hasImageClass}/g, '');
            } else {
              nmItem = nmItem
                .replace(/{backgroundImage}/g, '')
                .replace(/{hasImageClass}/g, '');
            }
          } else if (result.source == 'facebook') {
            //if item is facebook
            var nmItem = resultItemTemplates.socialFacebook;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle)
              .replace(/{description}/g, trunc(result.summary, maxwordsSummary));
          } else if (result.source == 'twitter') {
            //if item is twitter
            var nmItem = resultItemTemplates.socialTwitter;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle)
              .replace(/{description}/g, trunc(result.summary, maxwordsSummary));
          } else if (result.source == 'instagram') {
            //if item is instagram
            var nmItem = resultItemTemplates.socialInstagram;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{backgroundImage}/g, resultItemTemplates.partialBgImage.replace(/{backgroundImageURL}/g, encodeURI(result.image)))
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle);
          } else if (result.source == 'youtube') {
            //if item is youtube
            var nmItem = resultItemTemplates.socialYoutube;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{backgroundImage}/g, resultItemTemplates.partialBgImage.replace(/{backgroundImageURL}/g, encodeURI(result.image)))
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle);
          } else if (result.source == 'linkedin') {
            //if item is linkedin
            var nmItem = resultItemTemplates.socialLinkedin;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{title}/g, trunc(result.summary, maxwordsTitle))
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle);
          } else if (result.source == 'soundcloud') {
            //if item is linkedin
            var nmItem = resultItemTemplates.socialSoundcloud;
            nmItem = nmItem
              .replace(/{url}/g, result.url)
              .replace(/{title}/g, trunc(result.summary, maxwordsTitle))
              .replace(/{date}/g, formatDate(result.date))
              .replace(/{username}/g, result.handle);
          }

          //append grid item HTML to existing news HTML
          newsHTML += nmItem;
        });

        //create results DOM object
        var $newsElem = $(newsHTML);

        //let masonry finish initialising
        setTimeout(function () {
          $grid
            .append($newsElem)
            .masonry('appended', $newsElem);

          //reinit featherlight for dynamically added items
          initFeatherlight();

          //auto scroll to newly added results upon load
          if (autoscroll) {
            $('html, body').animate({
              scrollTop: $($newsElem[0])
                .offset()
                .top
            }, 500);
          }

          //show load more button again
          $('.btn--search-loadmore, .spinner--search-loadmore').removeClass('search-ajax-loading');

          //if no more items to load, hide load more button
          if (loadMoreParams === undefined) {
            $('.btn--search-loadmore').hide();
          } else {
            $('.btn--search-loadmore').show();
          }
        }, 1000);
      })
      .fail(function () {
        var loadMoreNews = document.querySelector('.btn--search-loadmore');
          if(loadMoreNews) {
            $('.btn--search-loadmore, .spinner--search-loadmore').removeClass('search-ajax-loading');
            loadMoreNews.style.display = "none";
          }  
          if(noDataMsg) {
            noDataMsg.style.display = 'block';
          }

      })
      .always(function () {});
  }

  var initSearchResultsGrid = function () {
    var masonryClass = '.content-grid__container--masonry';

    //init masonry component
    $grid = $(masonryClass).masonry({itemSelector: '.content-grid__item-container', columnWidth: '.grid-sizer', percentPosition: true, transitionDuration: 0, initLayout: false});

    //add listener to show once loaded
    $grid.on('layoutComplete', function () {
      $(masonryClass).css('opacity', 1);
    });

    //init layout
    $grid.masonry();
  }.bind($grid);

  //delay start masonry grid init (jquery race condition fix)
  setTimeout(initSearchResultsGrid, 100);

  /**
   * User action events
   */

  //on load more click
  $('.btn--search-loadmore').click(function () {
    //load more batches of news
    getAJAXNews(searchURL + loadMoreParams, true);
  });

  //on filter search submit
  $('.search-filter__form').submit(function (e) {
    e.preventDefault();

    var filterQueryParams = '';

    if (filterDateRange.length) {
      filterQueryParams += '&meta_d3=' + filterDateRange[0] + '&meta_d4=' + filterDateRange[1];
    }

    if (filterCategory) {
      filterQueryParams += '&' + filterCategory;
    }

    if (filterKeywords) {
      filterQueryParams += '&query=' + encodeURI(filterKeywords);
    }

    // alert(searchURL + searchParamsStatic + filterQueryParams); remove all
    // existing news items
    $('.content-grid__column--featured-in-search, .content-grid__item-container').remove();
    featuredNewsHTML = '';
    //reinit masonry grid
    initSearchResultsGrid();
    //get news
    getAJAXNews(searchURL + searchParamsStatic + filterQueryParams, false);
  });

  $('.search-filter__keywords').change(function () {
    filterKeywords = $(this).val();
    showHideClearFiltersBtn();
  });

  $('.search-results__clear-filters').click(function () {
    //reset UI
    $('.search-filter__category, .search-filter__keywords').val('');
    $('#search-daterangepicker')
      .data('dateRangePicker')
      .clear();

    //reset filter vars
    filterDateRange = [];
    filterCategory = '';
    filterKeywords = '';

    $('.search-results__clear-filters').hide();
    //remove all existing news items
    $('.content-grid__column--featured-in-search, .content-grid__item-container').remove();
    featuredNewsHTML = '';
    //reinit masonry grid
    initSearchResultsGrid();
    //get news
    getAJAXNews(searchURL + searchParamsStatic, false);
  });

  //show/hide clear filters btn
  function showHideClearFiltersBtn() {
    if (filterDateRange || filterCategory || filterKeywords) {
      $('.search-results__clear-filters').show();
    } else {
      $('.search-results__clear-filters').hide();
    }
  }

  /**
   * Update pagination info
   */

  function updatePaginationInfo() {
    //if there are results available
    if (resultSummary.totalMatching > 0) {
      var paginationInfo = 'Showing <strong>' + resultSummary.currEnd + ' of ' + numberWithCommas(resultSummary.totalMatching) + '</strong>';

      //if a category was selected
      /*
      if ($('.search-filter__category').val() !== '') {
        paginationInfo += ' for <strong>' + $('.search-filter__category option:selected').text() + '</strong>';
      }*/

      //if a query was entered
      if ($('.search-filter__keywords').val() !== '') {
        paginationInfo += ' for <strong>' + $('.search-filter__keywords').val() + '</strong>';
      }

      $('.search-results__pagination-info').html(paginationInfo);
    } else {
      $('.search-results__pagination-info').html('No results found based on your current filter criteria.');
    }
  }

  //init search if on search page

  if ($('.search-filter__form').length > 0) {
    /**
     * Modal init
     */
    var initFeatherlight = function () {
      $('.content-grid__item--modal').featherlight();
    };

    //hide clear filters onload
    $('.search-results__clear-filters').hide();

    //init modal
    initFeatherlight();

    //trigger search on page load i
    getAJAXNews(searchURL + loadMoreParams, false);

    /**
     * On Date range picker change
     *
     */

    var searchDateRangePicker = function () {
      if ($('#search-daterangepicker').length > 0) {
        $('#search-daterangepicker')
          .dateRangePicker({
            singleMonth: true,
            //alwaysOpen:            true,
            showTopbar: false,
            hoveringTooltip: false,
            monthSelect: true,
            yearSelect: true,
            format: 'D MMM',
            customArrowPrevSymbol: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#1F899' +
                '1" fill-rule="evenodd" d="M6.986.5L8.5 2.018 3.529 7 8.5 11.98 6.986 13.5.5 7z"/' +
                '></svg>',
            customArrowNextSymbol: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14"><path fill="#1F899' +
                '1" fill-rule="evenodd" d="M2.014.5L.5 2.018 5.471 7 .5 11.98l1.514 1.52L8.5 7z"/' +
                '></svg>'
          })
          .bind('datepicker-change', function (evt, obj) {
            filterDateRange = [
              moment(obj.date1).format('DMMMYYYY'),
              moment(obj.date2).format('DMMMYYYY')
            ];
            showHideClearFiltersBtn();
          });
      }
    };

    //delay start date range picker (jquery race condition fix)
    setTimeout(searchDateRangePicker, 1000);
  }

  /**
   * New CCT (Funnelback)
   */

  var initNewsCCT = function () {
    var newsCCTs = $('.une-mod-news-cct');
    //if there are CCTs on page
    if (newsCCTs.length > 0) {
      //foreach CCT
      newsCCTs
        .each(function () {
          var category = $(this).data('category');
          var targetElem = $(this).find('.content-grid__columns');
          var cctSearchURL = newsCCTs.data('fb-url') + searchParamsStatic + '&clive=une~ds-news';
          if (category !== '') {
            cctSearchURL += '&f.Categories%7Ccategory=' + category;
          }
          var jqxhr = $.getJSON(cctSearchURL, function () {}).done(function (data) {
              var newsData = data
                .fullResults
                .results
                .slice(0, 4);
              var newsHTML = '';

              $.each(newsData, function () {
                var nmItem = resultItemTemplates.newsCct;

                var result = this;

                nmItem = nmItem
                  .replace(/{url}/g, result.url)
                  .replace(/{date}/g, formatDate(result.date))
                  .replace(/{title}/g, trunc(result.title, maxwordsTitle))
                  .replace(/{description}/g, trunc(stripHtml(result.summary), maxwordsSummary));

                //if there is a background image
                if (result.image) {
                  nmItem = nmItem
                    .replace(/{backgroundImage}/g, resultItemTemplates.partialBgImage.replace(/{backgroundImageURL}/g, encodeURI(result.image)))
                    .replace(/{hasImageClass}/g, 'content-grid__item--has-image')
                    .replace(/{backgroundImage}/g, '')
                    .replace(/{hasImageClass}/g, '');
                } else {
                  nmItem = nmItem
                    .replace(/{backgroundImage}/g, '')
                    .replace(/{hasImageClass}/g, '');
                }

                newsHTML += nmItem;
              });

              targetElem.append(newsHTML);
            });
        });
    }
  };

  //init news CCT
  initNewsCCT();

    /**
   * News Listing CCT (Funnelback)
   */

  var initNewsListingCCT = function () {
    var newsListingCCTs = $('.une-mod-news-listing-cct');
    console.info('===== initNewsListingCCT =====');
    //if there are CCTs on page
    if (newsListingCCTs.length > 0) {
      //foreach CCT
      newsListingCCTs
        .each(function () {
          var category = $(this).data('category');
          var targetElem = $(this).find('.news-listing__list');
          var cctSearchURL = newsListingCCTs.data('fb-url') + searchParamsStatic + '&clive=une~ds-news';
          if (category !== '') {
            cctSearchURL += '&f.Categories%7Ccategory=' + category;
          }
          var jqxhr = $.getJSON(cctSearchURL, function () {}).done(function (data) {
              var newsData = data
                .fullResults
                .results
                .slice(0, 4);
              var newsHTML = '';

              $.each(newsData, function () {
                var nmItem = resultItemTemplates.newsListingCCT;

                var result = this;

                nmItem = nmItem
                  .replace(/{url}/g, result.url)
                  .replace(/{date}/g, formatDate(result.date))
                  .replace(/{title}/g, trunc(result.title, maxwordsTitle))
                  .replace(/{description}/g, trunc(stripHtml(result.summary), maxwordsSummary));

                newsHTML += nmItem;
              });

              targetElem.append(newsHTML);
            });
        });
    }
  };

  //init news CCT
  initNewsListingCCT();

  /**
   * Utility functions
   */

  //truncate words
  function trunc(phrase, max_words) {
    var truncated = phrase
      .split(' ')
      .splice(0, max_words)
      .join(' ');

    if (phrase.length > truncated.length) {
      truncated += '...';
    }

    return truncated;
  }

  function stripHtml(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  //format date; append show year only if its older than current year
  function formatDate(date) {
    var dateObject = moment(date);
    var formattedDate = dateObject
      .format('D MMM')
      .toUpperCase();
    if (dateObject.year() < moment().year()) {
      formattedDate += dateObject.format(' Y');
    }
    return formattedDate;
  }

  function numberWithCommas(num) {
    return num
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}(jQuery));
